// Action Constants

export enum ActionConstant {
	GET_DETAILS = 'FILE://PROFILE_MANAGEMENT/GET_DETAILS',
	GET_NORMAL_DETAILS = 'FILE://PROFILE_MANAGEMENT/GET_NORMAL_DETAILS',
	GET_ENTERPRISE_DETAILS = 'FILE://PROFILE_MANAGEMENT/GET_ENTERPRISE_DETAILS',
	GET_PROD_OWNER_ORG_DETAILS = 'FILE://PROFILE_MANAGEMENT/GET_PROD_OWNER_ORG_DETAILS',
	CLEAR_PROD_OWNER_ORG_DETAILS = 'FILE://PROFILE_MANAGEMENT/CLEAR_PROD_OWNER_ORG_DETAILS',
	GET_ORG_DETAILS = 'FILE://PROFILE_MANAGEMENT/GET_ORG_DETAILS',
	GET_ORG_SUMMARY_DETAILS = 'FILE://PROFILE_MANAGEMENT/GET_ORG_SUMMARY_DETAILS',
	GET_STATUS = 'FILE://PROFILE_MANAGEMENT/GET_STATUS',
	CLEAR_DETAILS = 'FILE://PROFILE_MANAGEMENT/CLEAR_DETAILS',
	CLEAR_NORMAL_DETAILS = 'FILE://PROFILE_MANAGEMENT/CLEAR_NORMAL_DETAILS',
	CLEAR_ENTERPRISE_DETAILS = 'FILE://PROFILE_MANAGEMENT/CLEAR_ENTERPRISE_DETAILS',
	CLEAR_ORG_DETAILS = 'FILE://PROFILE_MANAGEMENT/CLEAR_ORG_DETAILS',
	CLEAR_ORG_SUMMARY_DETAILS = 'FILE://PROFILE_MANAGEMENT/CLEAR_ORG_SUMMARY_DETAILS',
	CLEAR_STATUS = 'FILE://PROFILE_MANAGEMENT/CLEAR_STATUS',
}

// State Types

// Action Types
export interface Lists {
	type: ActionConstant.GET_DETAILS;
	count: number;
	rows: [];
}
export interface NormalLists {
	type: ActionConstant.GET_NORMAL_DETAILS;
	count: number;
	rows: [];
}
export interface EnterpriseLists {
	type: ActionConstant.GET_ENTERPRISE_DETAILS;
	count: number;
	rows: [];
}
export interface ProdOwnerOrgDetailsList {
	type: ActionConstant.GET_PROD_OWNER_ORG_DETAILS;
	count: number;
	rows: [];
}
export interface Org {
	name: string;
	id: number;
	activeEnterprisePlan?: boolean;
	enterpriseBillingEnabled?: boolean;
	primaryContact: string;
	location: string;
	phone: string;
	email: string;
	billingMethod?: 'invoice' | 'credit_card';
	billingContactName?: string;
	billingContactEmail?: string;
	billingCompanyName?: string;
	billingCompanyAddress?: string;
	billingPaymentBrand?: string;
	billingPaymentLast4?: string;
	billingPaymentExpMonth?: number;
	billingPaymentExpYear?: number;
	hasBillingPaymentMethod?: boolean;
}
export interface Orgsummary {
	organizationsTotal: number;
	paidOrganizations: number;
	trailPlanOrganizations: number;
	expired: number;
	totalIndexSubscribed: number;
	totalIndexUsed: number;
}

export interface GetListType {
	type: ActionConstant.GET_DETAILS;
	data: Lists;
}
export interface GetNormalListType {
	type: ActionConstant.GET_NORMAL_DETAILS;
	data: NormalLists;
}
export interface GetEnterpriseListType {
	type: ActionConstant.GET_ENTERPRISE_DETAILS;
	data: EnterpriseLists;
}
export interface GetProdOwnerOrgDetailsListType {
	type: ActionConstant.GET_PROD_OWNER_ORG_DETAILS;
	data: ProdOwnerOrgDetailsList;
}

export interface GetOrgType {
	type: ActionConstant.GET_ORG_DETAILS;
	data: Org;
}
export interface GetOrgSummaryType {
	type: ActionConstant.GET_ORG_SUMMARY_DETAILS;
	data: Orgsummary;
}
export interface GetStatusType {
	type: ActionConstant.GET_STATUS;
	status: number;
}

export interface ClearListType {
	type: ActionConstant.CLEAR_DETAILS;
}
export interface ClearNormalListType {
	type: ActionConstant.CLEAR_NORMAL_DETAILS;
}
export interface ClearEnterpriseListType {
	type: ActionConstant.CLEAR_ENTERPRISE_DETAILS;
}
export interface ClearProdOwnerOrgDetailsListType {
	type: ActionConstant.CLEAR_PROD_OWNER_ORG_DETAILS;
}

export interface ClearOrgType {
	type: ActionConstant.CLEAR_ORG_DETAILS;
}
export interface ClearOrgSummaryType {
	type: ActionConstant.CLEAR_ORG_SUMMARY_DETAILS;
}
export interface ClearStatusType {
	type: ActionConstant.CLEAR_STATUS;
}
export interface OrgDetails {
	count: number;
	projects: any[];
	users: any[];
	userCount: number;
}
export type ActionType =
	| GetListType
	| GetEnterpriseListType
	| GetProdOwnerOrgDetailsListType
	| GetNormalListType
	| GetStatusType
	| ClearListType
	| ClearEnterpriseListType
	| ClearProdOwnerOrgDetailsListType
	| ClearNormalListType
	| ClearStatusType
	| GetOrgType
	| ClearOrgType
	| GetOrgSummaryType
	| ClearOrgSummaryType;

export interface InitialState {
	listFetching: boolean;
	list: [];
	statusCode: number;
	count: number;
	orgdetails: Org;
	orgdetailsFetching: boolean;
	orgsummarydetails: Orgsummary;
	orgsummarydetailsFetching: boolean;
	enterpriselist: [];
	enterpriselistFetching: boolean;
	prodOwnerOrgDetails: OrgDetails[];
	prodOwnerOrgDetailsFetching: boolean;
	normallist: [];
	normallistFetching: boolean;
}
